import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./style.css";
import "./assets/styles/fonts.css";

import App from "./App.tsx";
import "./i18n.ts";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "react-hot-toast";

// import { HelmetProvider } from "react-helmet-async";

// Dev rejimida oldingi (masalan, preview/build sinovidan qolgan) Service Worker'larni
// avtomatik o'chiradi — aks holda ular eski JS chunk'larni keshlab, "Invalid hook call" /
// useContext xatolariga sabab bo'lishi mumkin.
if (import.meta.env.DEV && "serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => registration.unregister());
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <BrowserRouter>
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
        <Toaster position="top-center" />
      </QueryClientProvider>
    </StrictMode>
  </BrowserRouter>
);



// saa 
// asfjgdsvhj 
// FORCE_FULL_RELOAD_VITE